import { useQuery } from "react-query";

import { makeSimpleGetRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { RoyaltyPayor } from "./types";

export const useRoyaltyPayors = () =>
  useQuery(
    "royalty-payors",
    async () =>
      await makeSimpleGetRequest<RoyaltyPayor[]>(
        `${ORDERBOOK_URL}/royalty-payors/?include[]=permissions.*`,
      ),
    { staleTime: 1000 * 60 * 10 }, // 10 minutes
  );
